const SECTION_PAGE_TEST_IDS = {
  HEADER_DESCRIPTION: 'section-header-description',
  HEADER_TITLE: 'section-header-title',
  LATEST_ARTICLES: 'section-latest-articles',
  LATEST_STORIES: 'section-latest-stories',
  LATEST_STORIES_TITLE: 'section-latest-stories-title',
  SUBSECTION: 'subsection',
};
export default SECTION_PAGE_TEST_IDS;
